import {
    Home,
    BoxMinimalistic,
    Document,
    UsersGroupTwoRounded,
    Bill,
    BillList,
    TagHorizontal,
    FileText,
    Shop,
    Settings,
    Help,
    BookBookmarkMinimalistic,
    SliderVerticalMinimalistic,
    Logout2,
    UserCircle,
    MenuDotsSquare,
} from "@solar-icons/react/ssr";

import {
    PERMISSION_GET_PROJECTS,
    PERMISSION_GET_BILLS,
    PERMISSION_POST_BIDS,
    PERMISSION_GET_INVOICES,
    PERMISSION_EDIT_PERSONS,
    PERMISSION_EDIT_CLIENTS,
    PERMISSION_VIEW_ADMIN_PANEL,
    PERMISSION_VIEW_EXTERNAL_NAV_LINKS,
} from "@/auth/constants";
import {
    FEATURE_BIDS,
    FEATURE_INVOICES,
    FEATURE_COMMUNITY,
    FEATURE_MULTI_PERSON,
    FEATURE_GENERAL_TEMPLATES,
    FEATURE_VIEW_MAKERS_LINKS,
    FEATURE_VIEW_TRAINING_LINK,
    FEATURE_VIEW_HELP_LINK,
    FEATURE_VENDORS,
} from "@/constants";
import { setSupportOpen } from "@/nav/navSlice";

const menuItemsMain = [
    {
        title: "Dashboard",
        url: "/dashboard",
        icon: Home,
        permissions: [PERMISSION_GET_PROJECTS],
    },
    {
        title: "Projects",
        url: "/projects",
        icon: BoxMinimalistic,
        permissions: [PERMISSION_GET_PROJECTS],
    },
    {
        title: "Bid Sheets",
        url: "/bids",
        icon: Document,
        feature: FEATURE_BIDS,
        permissions: [PERMISSION_POST_BIDS],
    },
    {
        title: "Vendors",
        url: "/vendors",
        feature: FEATURE_VENDORS,
        permissions: ["get_projects"],
        icon: Shop,
    },
    {
        title: "Community",
        url: "/talent",
        icon: UsersGroupTwoRounded,
        feature: FEATURE_COMMUNITY,
    },
    // {
    //     title: "Community",
    //     url: "/talent",
    //     icon: UsersGroupTwoRounded,
    //     feature: FEATURE_COMMUNITY,
    // },
    {
        title: "Department",
        url: "/departments",
        icon: BookBookmarkMinimalistic,
        permissions: [PERMISSION_EDIT_CLIENTS],
    },
    {
        title: "Bills",
        url: "/bills",
        icon: Bill,
        feature: FEATURE_BIDS,
        permissions: [PERMISSION_GET_BILLS],
    },
    {
        title: "Vendor Bills",
        url: "/accounting-bills",
        feature: FEATURE_VENDORS,
        permissions: ["get_bills"],
        icon: BillList,
        // requiredStrategy: ACCOUNTING_STRATEGY
    },
    {
        title: "Invoices",
        url: "/invoices",
        icon: TagHorizontal,
        feature: FEATURE_INVOICES,
        permissions: [PERMISSION_GET_INVOICES],
    },
    // {
    //     title: "Templates",
    //     url: "https://drive.google.com/drive/folders/1t8ito2ZI9GuuJhFU4XlAmN7IpSsETsI5",
    //     icon: SliderVerticalMinimalistic,
    //     feature: FEATURE_GENERAL_TEMPLATES,
    // },
    // {
    //     title: "Reports",
    //     url: "/reports",
    //     icon: PieChartOutlineIcon,
    //     permissions: ["get_reports"],
    // }
];

const menuItemsExternal = [
    {
        title: "Contracts",
        url: "https://contracts.makers.to/",
        feature: FEATURE_VIEW_MAKERS_LINKS,
        permissions: [PERMISSION_VIEW_EXTERNAL_NAV_LINKS],
    },
    {
        title: "Brand",
        url: "https://brand.makers.to/",
        feature: FEATURE_VIEW_MAKERS_LINKS,
        permissions: [PERMISSION_VIEW_EXTERNAL_NAV_LINKS],
    },
    {
        title: "Wiki",
        url: "https://app.makers.to/",
        feature: FEATURE_VIEW_MAKERS_LINKS,
        permissions: [PERMISSION_VIEW_EXTERNAL_NAV_LINKS],
    },
    {
        title: "Bid Templates",
        url: "/bid-templates",
        feature: FEATURE_BIDS,
        permissions: [PERMISSION_POST_BIDS],
    },
    {
        title: "Team",
        url: "/team",
        feature: FEATURE_MULTI_PERSON,
        permissions: [PERMISSION_EDIT_PERSONS],
    },
    {
        title: "Admin",
        url: "/admin",
        permissions: [PERMISSION_VIEW_ADMIN_PANEL],
    },
    {
        title: "⚠️ Super Admin ⚠️",
        url: "/super-admin",
        requireSuperAdmin: true,
    },
];

const menuItemsSupport = [
    {
        title: "Training",
        url: "https://getmakeos.com/training",
        feature: FEATURE_VIEW_TRAINING_LINK,
    },
    {
        title: "Support",
        action: () => setSupportOpen(true),
        feature: FEATURE_VIEW_HELP_LINK,
    },
];

const menuItemsUser = [
    {
        title: "My Profile",
        url: "/profile",
        icon: UserCircle,
        feature: "community",
    },
    {
        title: "Manage Account",
        url: "/account",
        icon: Settings,
    },
    {
        title: "Logout",
        url: "/logout",
        icon: Logout2,
    },
];

const menus = [
    {
        title: "More",
        items: menuItemsExternal,
        icon: MenuDotsSquare,
    },
    {
        title: "Help",
        items: menuItemsSupport,
        icon: Help,
    },
];

const getActiveMenuItems = (token, hasFeature, items) => {
    const isMenuItemAllowed = (item) =>
        !item.permissions ||
        item.permissions.every((p) => token?.permissions?.includes(p));
    const showForSuperAdmin = (item) =>
        !item.requireSuperAdmin || token?.isSuperAdmin;
    const isFeatureEnabled = (item) =>
        !item.feature || (hasFeature && hasFeature(item.feature));

    return items
        .filter(isMenuItemAllowed)
        .filter(showForSuperAdmin)
        .filter(isFeatureEnabled);
};

const getMenuItemsMain = (token, hasFeature) =>
    getActiveMenuItems(token, hasFeature, menuItemsMain);
const getMenuItemsExternal = (token, hasFeature) =>
    getActiveMenuItems(token, hasFeature, menuItemsExternal);
const getMenuItemsSupport = (token, hasFeature) =>
    getActiveMenuItems(token, hasFeature, menuItemsSupport);
const getMenus = (token, hasFeature) =>
    menus.map((menu) => ({
        ...menu,
        items: getActiveMenuItems(token, hasFeature, menu.items),
    }));
const getMenuItemsUser = (token, hasFeature) =>
    getActiveMenuItems(token, hasFeature, menuItemsUser);

export {
    getMenuItemsMain,
    getMenuItemsExternal,
    getMenuItemsSupport,
    getMenus,
    getMenuItemsUser,
};
